export const MFButton = ({
  children,
  onClick,
  disabled,
  className,
  style,
  height,
  cancelButton,
  variant = "primary",
  width,
  outlined,
  big,
  huge,
}) => {
  return (
    <button
      className={`btn py-0 fw-500 ${cancelButton ? "cancel-button" : `btn-${variant}`} ${width ? "" : "px-1"} ${outlined ? "outlined" : ""} ${className || ""}`}
      onClick={onClick}
      disabled={disabled}
      style={{
        height: height || 38,
        width: width || "fit-content",
        lineHeight: "normal",
        fontSize: huge ? 17 : big ? 15 : 13,
        padding: 0,
        borderRadius: huge ? 8 : big ? 6 : 4,
        ...style,
      }}
    >
      {children}
    </button>
  );
};
